/**
 * RTWO Blockchain Protocol Engine — Client-Safe Exports
 *
 * Domain models and static readiness metadata only.
 * Do not import protocol-engine or services from client components.
 */

export type {
  BlockStatus,
  TransactionStatus,
  ProtocolHash,
  ProtocolAddress,
  RTWOBlock,
  RTWOTransaction,
  RTWOAccount,
  RTWOState,
  RTWOReceipt,
  RTWOMempool,
} from './domain-models';

export {
  BLOCK_LIFECYCLE,
  TRANSACTION_LIFECYCLE,
  PROTOCOL_VERSION,
  PROTOCOL_ENGINE_VERSION,
  createEmptyBlock,
  createEmptyTransaction,
  createEmptyAccount,
  createEmptyState,
  createEmptyReceipt,
  createEmptyMempool,
} from './domain-models';

export { PROTOCOL_SERVICE_IDS, PROTOCOL_ENGINE_LAYER, PHASE3_READINESS_CHECKLIST } from './readiness';
